// ── PETLING IMAGE SLOTS ────────────────────────────────────────────────────
// Every image on the four Petling pages lives here.
// Paste a direct image URL (e.g. https://i.ibb.co/xxxx/name.png) into `url`
// and the image appears on that page.
//
// SHOW_PLACEHOLDERS = true  -> empty slots show a dashed "add image" box
// SHOW_PLACEHOLDERS = false -> empty slots are hidden completely
export const SHOW_PLACEHOLDERS = false;

export interface ImageSlotEntry {
  url: string;
  hint: string;
}

export const IMAGES: Record<string, ImageSlotEntry> = {
  // ── Home page project cards (thumbnail + large preview) ──
  "card-app":       { url: "https://i.ibb.co/SXv8X3pM/1.png", hint: "Card image for Petling Mobile App" },
  "card-admin":     { url: "https://i.ibb.co/zTPMbLMh/petling-admin-project-card.png", hint: "Card image for Petling Admin" },
  "card-providers": { url: "https://i.ibb.co/B2tKJBBB/Petling-provider.png", hint: "Card image for Petling for Providers" },
  "card-website":   { url: "https://i.ibb.co/0RRV5Swx/petling-website.png", hint: "Card image for Petling Website" },

  // ── 1. Petling Mobile App ──
  "app-hero":        { url: "https://i.ibb.co/jvJCh77G/899shots-so.png", hint: "Hero: app screens together, portrait" },
  "app-overview":    { url: "https://i.ibb.co/W4t28r5q/mobile-app-live-on-ios-and-android.png", hint: "Overview: the app live on iOS and Android" },
  "app-gallery-1":   { url: "https://i.ibb.co/SXv8X3pM/1.png", hint: "Home" },
  "app-gallery-2":   { url: "https://i.ibb.co/q3B01gsc/2.png", hint: "Medical documents organized" },
  "app-gallery-3":   { url: "https://i.ibb.co/5h33d4Zn/6.png", hint: "Care Team" },
  "app-gallery-4":   { url: "https://i.ibb.co/HT9cLb42/5.png", hint: "Smart Reminders" },
  "app-gallery-5":   { url: "https://i.ibb.co/ZpVyWpbm/3.png", hint: "Weight Logs" },
  "app-gallery-6":   { url: "https://i.ibb.co/9Hwn5n4R/app-screenshots.png", hint: "Care Sessions" },

  // ── 2. Petling Admin ──
  "admin-hero":      { url: "https://i.ibb.co/zTPMbLMh/petling-admin-project-card.png", hint: "Hero: the admin dashboard" },
  "admin-overview":  { url: "https://i.ibb.co/XxZLMhxp/518shots-so.png", hint: "Overview: the admin console" },

  // ── 3. Petling for Providers ──
  "providers-hero":     { url: "https://i.ibb.co/B2tKJBBB/Petling-provider.png", hint: "Hero: the provider desk" },
  "providers-overview": { url: "https://i.ibb.co/M594qh41/978shots-so.png", hint: "Overview: a pet's page and timeline" },
  "providers-detail":   { url: "https://i.ibb.co/N2gBpnR0/new-provider-details.png", hint: "Provider details" },

  // ── 4. Petling Website & Brand ──
  "website-hero":      { url: "https://i.ibb.co/0RRV5Swx/petling-website.png", hint: "Hero: petling.app homepage" },
  "website-overview":  { url: "https://i.ibb.co/G4tWtRcv/website-2.png", hint: "Overview: petling.app" },
  "website-features":  { url: "https://i.ibb.co/HLGwHkgS/features.png", hint: "Features page" },
  "website-support":   { url: "https://i.ibb.co/20T20tJM/support.png", hint: "Support page" },
  "website-story":     { url: "https://i.ibb.co/BWm6Pvb/our-story.png", hint: "Our Story page" },
  "website-logo":      { url: "https://i.ibb.co/hJkzqDkX/app-logo-white-background.png", hint: "Logo on a white background" },
};
